<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Update Area</h2>
            </div>
        </div>

        <a-card v-if="area">
            <a-form :form="form" @submit="handleSubmit">
                <a-form-item label="Name">
                  <a-input size="large"
                      v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }],
                                    initialValue: area.name }]"
                      placeholder="Enter name"
                  />
                </a-form-item>
                <a-form-item label="Division">
                    <a-select size="large"
                        show-search
                        :filter-option="filterOption"
                        v-decorator="['division_id', { rules: [{ required: true, message: 'Please select Hub' }],
                                    initialValue: area.division.id }]"
                        placeholder="Select Division" style="width: 100%">
                        <template v-if="area.division && area.division.id && area.division.status === 0">
                            <a-select-option :key="area.division.id" :value="area.division.id">
                                    {{area.division.name_en}}
                            </a-select-option>
                        </template>
                        
                        <template v-for="division in divisions" >
                            <a-select-option :key="division.id" :value="division.id">
                                {{division.name_en}}
                            </a-select-option>
                        </template>
                    </a-select>
                </a-form-item>

                <a-form-item label="Status">
                    <a-select size="large"
                        v-decorator="[
                        'status',
                        { rules: [{ required: true, message: 'Please select Status!' }],
                                initialValue: area.status }]"
                        placeholder="Select Status"
                    >
                        <a-select-option :value="1">
                            Active
                        </a-select-option>
                        <a-select-option :value="0">
                            Inactive
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item >
                    <a-button type="primary" class="btn btn-xs" size="large" html-type="submit">
                        Update Area
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
        <a-card v-else>
            <h4>Area not find</h4>
        </a-card>
    </div>
</template>

<script>
import { DIVISION_LIST, AREA_LIST, AREA_UPDATE } from "../../../script/api";
import { getData, postData } from "../../../script/api-service";
import {alertPop} from "../../../script/helper";

export default {
    props: ['areaId'],
    data() {
        return {
            form: this.$form.createForm(this, { name: 'coordinated' }),
            divisions: [],
            area: null
        };
    },
    methods: {
        async getDivision() {
            let res = await getData(DIVISION_LIST + '?status=1');

            if (res) {
                let masterData = res.data?.data;
                this.divisions = masterData || [];
            }
        },
        async getArea() {
            let res = await getData(AREA_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.area = masterData.find(e => e.id == this.areaId)
            }
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields( async(err, values) => {
                if (!err) {
                    let data = {};
                    
                    if (this.area.division_id != values.division_id) data.division_id = values.division_id;
                    if (this.area.name !== values.name) data.name = values.name;
                    if (this.area.status !== values.status) data.status = values.status;
                    
                    if (Object.keys(data).length) { 
                        data.area_id = this.areaId;

                        let res = await postData(AREA_UPDATE, data);

                        if (res) {
                            alertPop('success', 'Area updated successfully!');
                        }
                    } else {
                        alertPop('warning', 'No change found');
                    }
                }
            });
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    },
    mounted() {
        this.getDivision();
        this.getArea();
    },
}
</script>